import Axios from "axios";
import { adminApi } from "../config";

const endpoint = "/projects";

export const listAllProjects = async (params: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.get(url, {
      params,
    });
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const listProjectsForForms = async () => {
  try {
    let url = `${endpoint}/for-forms`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const regenerateApiKeyForProject = async (projectId: string) => {
  try {
    let url = `${endpoint}/${projectId}/api-key`;
    const result = await adminApi.put(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const getProjectById = async (id: string) => {
  try {
    let url = `${endpoint}/${id}`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const createProject = async (data: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.post(url, data);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const updateProject = async (projectId: string, projectData: any) => {
  try {
    let url = `${endpoint}/${projectId}`;
    const result = await adminApi.put(url, projectData);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const deleteProject = async (templateId: string) => {
  try {
    let url = `${endpoint}/${templateId}`;
    const result = await adminApi.delete(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};
